import React, { Component } from "react";
import PropTypes from "prop-types";

import "./Tab.css";

class Tab extends Component {
  static propTypes = {
    activeTab: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  onClick = () => {
    const { label, onClick } = this.props;
    onClick(label);
  };
 
  render() {
    const {
      onClick,
      props: { activeTab, label },
    } = this;

    let liClassName =
      "mn-profile-nav--menu-links uk-flex uk-flex-column mn-profile-nav--menu-links-notselect";
    let labelClassName =
      "mn-RD-profile__menu-text mn-profile-nav--menu-text-notselect";
    let underlineClassName =
      "mn-RD-profile__selected-nav mn-profile-nav--menu-notunderline";

    if (activeTab === label) {liClassName =
        "mn-profile-nav--menu-links uk-flex uk-flex-column mn-profile-nav--menu-links-select";
      labelClassName =
        "mn-RD-profile__menu-text mn-profile-nav--menu-text-select";
      underlineClassName =
        "mn-RD-profile__selected-nav mn-profile-nav--menu-underline";
    }

    return (
      // key={key}
      <li  className={liClassName} onClick={onClick}>
        <a className={labelClassName}>{label}</a>
        <div className={underlineClassName}>&nbsp;</div>
      </li>
    );
  }
}

export default Tab;
